// extracted by mini-css-extract-plugin
export default {"skeletonBar":"_1dfnjmf","pills":"_xsh4ff","tab":"_1jjle7a"};